import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { verifyProvisionTenant } from '@api/employerRegistration';
import { VerifyEmailData } from '@model/employer';
import WithRender from './VerifyEmail.html';

@WithRender
@Component({})
export default class VerifyEmail extends Vue {

    @Prop()
    public verifyEmailData: VerifyEmailData;

    public passwordLength = 6;
    public verificationCode: string = '';

    public isRequestInProgress = false;

    public get isInvalid() {
        return this.verificationCode.length === this.passwordLength ? false : true;
    }

    public onVerifyEmail() {

        if (this.isInvalid) {
            return;
        }

        this.isRequestInProgress = true;

        verifyProvisionTenant(this.verifyEmailData.requestId, 'Verify', this.verificationCode)
            .then((response) => {
                this.isRequestInProgress = false;

                if (response.requestType === 'Verify') {
                    this.$emit('next', 5);
                } else {
                    this.$snackbar.success({ message: `Email sent to ${this.verifyEmailData.email}. Please check your inbox` });
                }
            })
            .catch((e) => {
                this.$snackbar.error({ message: e.body.message || 'Unable to process request.' });
                this.isRequestInProgress = false;
            });
    }

    public resendEmail() {

        verifyProvisionTenant(this.verifyEmailData.requestId, 'Resend')
            .then(() => this.$snackbar.success({ message: `Email sent to ${this.verifyEmailData.email}.` }))
            .catch((e) => {
                this.$snackbar.error({ message: e.body.message || 'Unable to process request.' });
                this.isRequestInProgress = false;
            });
    }

    public onEnterKeyPress(value: string) {
        if (value.length === this.passwordLength) {
            this.isRequestInProgress = true;
            this.onVerifyEmail();
        }
    }
}
